export const CONTENT_CREATOR = 'marketplace-embed::content-creator';